module.exports = __webpack_public_path__ + "static/img/6.29e9a154.png";